<section>
    <div id="overlay" class="hidden" (click)="toggleDropDown()"></div>
    <div class="content">
        <header>
        <div class="kanban"></div>
        <div class="menu">
            <a id="help-button-header" (click)="toggleHelp()"><div class="help help-button-header"></div></a>
            <span id="user" (click)="toggleDropDown()">{{initialsUser}}</span>
        </div>
        </header>
        <div id="drop-down" class="hidden">
            <a (click)="toggleHelp(); closeDropDown()"><p id="help" class="help-button-dropdown">Help</p></a>
            <a (click)="closeHelp(); closeDropDown()" routerLink="/legalNotice"><p>Legal Notice</p></a>
            <a (click)="closeHelp(); closeDropDown()" routerLink="/privacy"><p>Privacy</p></a>
            <p (click)="logOut(); closeHelp(); closeDropDown()">Log out</p>
        </div>
    </div>
</section>